export default "__VITE_ASSET__33d96919__"